import React, { useEffect, useState } from "react"
import "register/less/registration.less"
import { useTranslation } from 'react-i18next'
import EnterEmailComponent from "./EnterEmailComponent"



const GetStartedComponent = (props) => {
    const [secondTitle, setSecondTitle] = useState("")
    const { t } = useTranslation()
    const secondTitlesOs = ['getstarted.encourage.title.two_os_1', 'getstarted.encourage.title.two_os_2',
        'getstarted.encourage.title.two_os_3', 'getstarted.encourage.title.two_os_4']

    useEffect(() => {
        if (props.isShgRegistration) {
            setSecondTitle('getstarted.encourage.title.two_os_1')
            let index = 1
            const intervalId = setInterval(() => {
                if (index == secondTitlesOs.length) {
                    index = 0
                }
                setSecondTitle(secondTitlesOs[index])
                index++
            }, 4000)

            return () => clearInterval(intervalId)
        }
        setSecondTitle('getstarted.encourage.title.two')
    }, [props.isShgRegistration])

    const setRegistrationData = (regData) => {
        props.setRegistrationData(
            {
                email: regData.email,
                externalEmail: regData.externalEmail,
                userId: regData.userId,
                accessToken: regData.accessToken,
                marketId: regData.marketId,
                offerIncrowdRegistration: regData.offerIncrowdRegistration,
                alreadySHGMember: regData.alreadySHGMember,
                offerOSRegistration: regData.offerOSRegistration,
            })
    }

    const setEmailValue = (email) => {
        props.setEmail(email)
    }

    return (
        <div id="registration-hero">
            <div className="white-block-forms" id="registration-slider">
                <div className="carousel slide slide-view" data-ride="carousel" id="carousel-32">
                    <div className="carousel-inner"><div className="item slide-content slide-1 active">
                        <div className="step get-started">
                            <div className='split-hero-container'>
                                <div className='split-hero'>
                                    <div className='split-hero-left encouragement-content'>
                                        <div className='split-hero-inner'>
                                            <h3 className='split-hero-title'>
                                                {props.isShgRegistration ? t('getstarted.encourage.title_os') : t('getstarted.encourage.title')}
                                                <br />
                                                <span className='split-hero-title-two'>
                                                    {t(secondTitle)}
                                                </span>
                                            </h3>
                                            <p className='split-hero-subtitle registration-subtitle'>
                                                <span>
                                                    {props.isShgRegistration ? t('getstarted.encourage.subtitle_os') : t('getstarted.encourage.subtitle_1')}
                                                </span>
                                            </p>
                                            <p className='split-hero-subtitle registration-subtitle'>
                                                <span>
                                                {props.isShgRegistration ? "": t('getstarted.encourage.subtitle_2')}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='split-hero-right'>
                                        <EnterEmailComponent
                                            setRegistrationData={setRegistrationData}
                                            setEmail={setEmailValue}
                                            email={props.email}
                                            referredId={props.referredId}
                                            token={props.token}
                                            referrerDescription={props.referrerDescription}
                                            url={props.url}
                                            src={props.src}
                                            responderTypeId={props.responderTypeId}
                                            languageId={props.languageId}
                                        />
                                        {
                                        props.showYotiMessage &&
                                        <div className="yoti-get-started">
                                        <img src="/images/info_icon_blue.svg" className="info-icon"></img>
                                        <div class="content-text">
                                        {t('yoti.message_info_1')}: <span>{t('yoti.message_info_2')}</span>
                                        </div>
                                        </div>
                                        }
                                        <div className="registration-help">
                                            <span>{t('getstarted.questions_os')}
                                                 <a className="email-support-link"
                                                 href={props.isShgRegistration ? 'mailto:helpdesk@opinionsite.com' : 'mailto:support@incrowdnow.com'}>{t('getstarted.questions_os.support_team')}</a>
                                                 {t('getstarted.questions_os.help')}</span>
                                        </div>

                                        <div className="line-2" />

                                        <div className="member-container">
                                            <a className='registration-member' href={props.isShgRegistration ? "/login/#responder" : "/login"}>
                                                {props.isShgRegistration ? t('getstarted.already_a_member_os') : t('getstarted.already_a_member')}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetStartedComponent